import React from 'react';

export default function asyncComponent(importComponent) {
    class AsyncComponent extends React.Component {
        constructor(props) {
            super(props);

            this.state = {
                component: null,
            };
        }

        async componentDidMount() {
            const { default: component } = await importComponent();
            this.setState({ component }); // eslint-disable-line react/no-did-mount-set-state
        }

        render() {
            const C = this.state.component;
            const { children, ...other } = this.props;

            return C ? <C {...other} /> : children || null;
        }
    }

    return AsyncComponent;
}
